export { default as NoSSSR } from './NoSSSR'
